export const HOME_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS: Record<string, string> =
  {
    'pillow/square-throw':
      'A compact decorative pillow with equal-length sides.',
    'pillow/lumbar':
      'A low rectangular pillow shaped to support the lower back.',
    'pillow/bolster': 'A long cylindrical pillow closed by round end panels.',
    'pillow/round':
      'A circular pillow finished with a seam around its outer edge.',
    'pillow/floor-cushion':
      'A large low cushion with a broad surface for floor seating.',
    'pillow/body':
      'An extra-long rectangular pillow proportioned for full-body support.',
    'pillow/wedge':
      'A triangular-profile pillow with a top plane that slopes upward.',
    'pillow/neck-roll':
      'A small cylindrical pillow proportioned to support the neck.',
    'pillow/euro':
      'A large square pillow proportioned for layered bed styling.',
    'pillow/boudoir':
      'A small rectangular pillow intended as a compact decorative accent.',
    'pillow/box-cushion':
      'A cushion with flat faces joined by a vertical boxed side panel.',
    'pillow/backrest':
      'An upright support pillow stabilized by a broad lower base.',

    'wall-art/framed-print':
      'A flat printed artwork enclosed by a visible perimeter frame.',
    'wall-art/canvas':
      'Artwork on wrapped textile with visible stretcher-depth edges.',
    'wall-art/poster': 'An unframed artwork printed on a thin, flat sheet.',
    'wall-art/textile-hanging':
      'A soft textile panel suspended visibly along its upper edge.',
    'wall-art/diptych':
      'One artwork composed across two coordinated panels with a deliberate gap.',
    'wall-art/triptych':
      'One artwork composed across three coordinated panels with deliberate gaps.',
    'wall-art/panel-set':
      'A modular wall arrangement made from multiple coordinated panels.',
    'wall-art/sculptural-relief':
      'A shallow wall-mounted artwork with forms raised from its surface.',
    'wall-art/metal-wall-art':
      'A wall-mounted composition of rigid metal elements set away from the wall.',
    'wall-art/wood-wall-art':
      'A rigid wood-based artwork with visible depth beyond a flat image.',
    'wall-art/tapestry':
      'A large woven wall hanging with a soft, naturally draped edge.',
    'wall-art/shadow-box':
      'A deep framed display with objects or artwork recessed inside.',

    'blanket/throw': 'A compact rectangular blanket sized for a sofa or chair.',
    'blanket/bed-blanket':
      'A large rectangular blanket proportioned to cover a mattress.',
    'blanket/weighted':
      'A substantially weighted blanket with fill distributed evenly across its body.',
    'blanket/electric':
      'A blanket panel with an integrated connection for powered controls.',
    'blanket/picnic':
      'A portable rectangular blanket sized to unfold across the ground.',
    'blanket/baby': 'A small rectangular blanket proportioned for an infant.',
    'blanket/outdoor':
      'A ground-capable blanket with a reinforced perimeter for outdoor use.',
    'blanket/wearable':
      'A body-wrapping blanket shaped with openings for the arms.',
    'blanket/stadium': 'A portable rectangular blanket sized to cover the lap.',
    'blanket/travel':
      'A packable blanket proportioned to cover the body while traveling.',
    'blanket/cooling':
      'A thin body-covering blanket with a flat, breathable construction.',
    'blanket/emergency':
      'An ultrathin foldable sheet sized to provide full-body coverage.',

    'sofa/three-seat':
      'A continuous sofa body proportioned to seat three people.',
    'sofa/loveseat': 'A compact sofa body proportioned to seat two people.',
    'sofa/sectional':
      'A sofa built from joined sections with a corner or chaise extension.',
    'sofa/modular':
      'A sofa made from separable seating units that can be rearranged.',
    'sofa/corner':
      'A sofa planned around a right angle with an integrated corner seat.',
    'sofa/chaise': 'A single elongated seat with a deck supporting the legs.',
    'sofa/sofa-bed':
      'A sofa with an integrated deck that converts into a sleeping surface.',
    'sofa/curved':
      'A sofa with an arcing seat plan and a back following the same curve.',
    'sofa/chesterfield':
      'A deep buttoned sofa with rolled arms level with the back.',
    'sofa/tuxedo':
      'A box-like sofa with straight arms matching the height of the back.',
    'sofa/track-arm':
      'A sofa with straight rectangular arms and clean vertical faces.',
    'sofa/roll-arm': 'A sofa with arms that curve outward into rounded fronts.',
    'sofa/armless':
      'A sofa composed only of seat and back, leaving both sides open.',

    'lamp/table':
      'A compact lamp with a freestanding base beneath the light head or shade.',
    'lamp/floor': 'A floor-standing lamp with a tall freestanding stem.',
    'lamp/desk-task':
      'A compact desk lamp with an adjustable task light and base or clamp.',
    'lamp/bedside':
      'A low compact lamp designed to cast soft light at close range.',
    'lamp/reading':
      'A lamp with a directional head and a positionable arm or stem.',
    'lamp/portable':
      'A self-contained lamp with a compact base or integrated carrying grip.',
    'lamp/arc':
      'A lamp with a long curved arm holding an offset overhead light.',
    'lamp/torchiere':
      'A tall upright lamp that directs light from an upward-facing bowl.',
    'lamp/bankers':
      'A task lamp with a horizontal shade on a short articulated stem.',
    'lamp/tripod':
      'A lamp with a raised light head supported by a three-legged base.',
    'lamp/mushroom':
      'A compact lamp with a domed shade on a short centered stem.',

    'plate/dinner': 'A large round eating plate with a shallow raised rim.',
    'plate/side':
      'A small round plate for side portions with a shallow raised rim.',
    'plate/salad':
      'A medium round plate with a shallow rim for serving salads.',
    'plate/dessert':
      'A small presentation plate with a clearly defined perimeter rim.',
    'plate/pasta':
      'A plate with a wide rim surrounding a shallow central bowl.',
    'plate/soup': 'A plate with a broad rim surrounding a deeper central bowl.',
    'plate/charger':
      'An oversized flat plate with a broad decorative rim for layered settings.',
    'plate/appetizer':
      'A compact plate with a small surface for serving appetizers.',
    'plate/bread-and-butter':
      'A very small round plate with a shallow perimeter rim.',
    'plate/compartment':
      'A divided plate with raised partitions separating its eating areas.',
    'plate/tasting':
      'A small presentation plate proportioned for a single bite.',
    'plate/saucer': 'A small shallow dish with a central recess for a cup.',

    'vase/bud': 'A small upright vase with a narrow opening for a single stem.',
    'vase/cylinder': 'A round open vase with straight vertical walls.',
    'vase/bottle':
      'A vase with a narrow neck rising from a broader lower body.',
    'vase/amphora': 'A rounded vase with a narrow neck and two side handles.',
    'vase/floor':
      'A tall freestanding vase proportioned to stand on the floor.',
    'vase/bulbous':
      'A vase with a wide rounded body narrowing toward the mouth.',
    'vase/fluted':
      'A vase shaped by repeated vertical ribs running along its body.',
    'vase/pedestal': 'A vase with its vessel body raised above a footed stem.',
    'vase/wide-mouth':
      'A vase with a broad open rim and a generously open neck.',
    'vase/hanging':
      'A lightweight vase body designed to hang from a suspension point.',
    'vase/wall':
      'A wall-mounted vase with a flat back and forward-projecting vessel.',
    'vase/organic-form':
      'An asymmetrical vase defined by irregular, flowing contours.',

    'mug/classic':
      'A cylindrical drinking mug with a handle attached at the side.',
    'mug/espresso':
      'A small drinking mug with a proportionally compact side handle.',
    'mug/latte': 'A tall drinking mug with a handle attached at the side.',
    'mug/camp': 'A straight utility mug with a rounded rim and side handle.',
    'mug/travel': 'A tall lidded mug with a dedicated aperture for drinking.',
    'mug/insulated':
      'A lidded mug with a double-wall body for thermal insulation.',
    'mug/beer-stein':
      'A large handled mug with a substantial base and wide drinking rim.',
  };
